<template>
  <div style="position: relative">
    <sc-drop
        accept="node"
        @drop="$emit('move', [$event, node, 'before'])"
        v-slot="{ dragging }"
        v-model="hoverBefore"
    >
      <div
          style="position: absolute; height: 14px; width: 100%; z-index: 10"
          v-show="dragging"
      />
    </sc-drop>
    <sc-drop
        accept="node"
        @drop="$emit('move', [$event, node, 'inside'])"
        v-slot="{ hover }"
    >
      <div
          class="line"
          :style="{ paddingLeft: node.level * 22 + 'px' }"
          @click="node.select(!node.selected)"
          :class="{ active: node.selected }"
          ref="line"
      >
        <span class="arrow" @click="node.setOpen(!node.opened)">
          <sc-icon
              v-show="node.children.length > 0"
              :type="node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'"
          />
        </span>
        <div class="line-content" :class="{ hover, hoverBefore }">
          <sc-drag format="node" :data="node.id" :img="{ el: line }">
            <span class="drag">
              <sc-icon type="HolderOutlined"/>
            </span>
          </sc-drag>
          <span class="checkbox">
            <a-checkbox
                :checked="node.checked === 'yes'"
                :indeterminate="node.checked === 'half'"
                @click="node.check(node.checked !== 'yes')"
            />
          </span>
          <div class="content">
            <span class="icon"><sc-icon :type="node.data.class"/></span>
            <a-input
                class="class"
                size="small"
                :value="node.data.class"
                @update:value="$emit('data', { class: $event })"
            />
            <a-input
                class="title"
                size="small"
                :value="node.data.title"
                @update:value="$emit('data', { title: $event })"
            />
            <a-input
                class="path"
                size="small"
                style="margin-right: 10px"
                :value="node.data.path"
                @update:value="$emit('data', { path: $event })"
                v-if="node.level > 0 && node.children.length === 0"
            />
            <sc-btn
                text="add"
                size="small"
                style="margin-right: 10px"
                :handler="() => $emit('add')"
                v-if="node.level !== 2"
            />
            <sc-btn
                text="del"
                size="small"
                type="danger"
                confirm="确定"
                :handler="() => node.del()"
                style="margin-right: 10px"
            />
          </div>
        </div>
      </div>
    </sc-drop>
  </div>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import {DataNode} from '@/components/common/tree/TreeUtil';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import ScDrop from '@/components/common/drag/ScDrop';
import ScDrag from '@/components/common/drag/ScDrag';

defineEmits<{
  (event: "data", data: { class?: string; title?: string; path?: string }): void;
  (event: "add"): void;
  (event: "move", data: [boolean, DataNode<unknown>, string]): void;
}>()

withDefaults(defineProps<{
  node: DataNode<unknown>;
  menu?: Array<{ title: string; handler: () => void }>;
}>(), {
  menu: () => ([] as Array<{ title: string; handler: () => void }>),
})

const hoverBefore = ref(false)
const line = ref(null)

</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: row;
  align-items: center;

  .line-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid transparent;

    &.hoverBefore {
      border-top: 1px solid $color-primary;
    }

    &.hover {
      border: 1px solid $color-primary;
    }
  }

  .arrow {
    width: 16px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
  }

  .drag {
    width: 30px;
    height: 30px;
    font-size: $font-size-large;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.active {
    .title {
      //background-color: #82c3ff;
    }
  }
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon {
    font-size: 18px;
    margin-right: $spacing-small;
  }

  .class {
    width: 150px;
    margin-right: 10px;
  }

  .title {
    width: 180px;
    margin-right: 10px;
  }

  .path {
    width: 220px;
  }
}
</style>
